import { Component, OnInit, signal } from '@angular/core';
import { Hero } from '../../common/hero/hero';

@Component({
  selector: 'app-home-page',
  imports: [Hero],
  templateUrl: './home-page.html',
  styleUrl: 'home-page.scss',
})
export class HomePage implements OnInit {

  curentImgShown = signal(0);
  imgNameArray = ['1.jpg', '2.jpg', '4.jpg'];
  private intervalId?: number;
  joursRestants?: string;
  emphasis: boolean = false;

  ngOnInit(): void {
    this.resetSlideTimer();

    const aujourdhui = new Date();
    const cible = new Date(2027, 7, 21);

    aujourdhui.setHours(0, 0, 0, 0);
    cible.setHours(0, 0, 0, 0);

    const absoluteJoursRestants = Math.ceil((cible.getTime() - aujourdhui.getTime()) / (1000 * 60 * 60 * 24));

    if (absoluteJoursRestants === -1) {
      this.emphasis = true;
      this.joursRestants = "C'était hier !";
    } else if (absoluteJoursRestants === 1){
      this.emphasis = true;
      this.joursRestants = "J - " + absoluteJoursRestants + "\u00a0 \u00a0—\u00a0 \u00a0C'est demain !";
    }  else if (absoluteJoursRestants < 0) {
      this.joursRestants = "C'était il y a " + (absoluteJoursRestants * -1) + " jour(s) !";
    } else if (absoluteJoursRestants > 0){
      this.joursRestants = "J - " + absoluteJoursRestants;
    } else {
      this.emphasis = true;
      this.joursRestants = "C'est Ajourd'hui !";
    }
  }

  slideNext(): void {
    if (this.imgNameArray.length === this.curentImgShown() + 1) {
      this.curentImgShown.set(0);
    } else {
      this.curentImgShown.set(this.curentImgShown() + 1);
    }
    this.resetSlideTimer();
  }

  slidePrevious(): void {
    if (this.curentImgShown() === 0) {
      this.curentImgShown.set(this.imgNameArray.length - 1);
    } else {
      this.curentImgShown.set(this.curentImgShown() - 1);
    }
    this.resetSlideTimer();
  }

  goToSlide(slideNumber: number) {
    this.curentImgShown.set(slideNumber);
    this.resetSlideTimer();
  }

  resetSlideTimer() {
    clearInterval(this.intervalId);
    this.intervalId = setInterval(() => {
      this.slideNext();
    }, 5000);
  }
}

